import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import React, { useState } from 'react'

import iconArrowDownDark900 from '../../assets/icons-light-theme/icon-arrow-down-dark900.svg'
import iconArrowUpDark900 from '../../assets/icons-light-theme/icon-arrow-up-dark900.svg'
import { ImageIcon } from '../ImageIcon'
import {
  StyledDropdown,
  StyledDropdownMenu,
  StyledDropdownSettingsMenu,
  StyledDropdownSettingsToggle,
  StyledDropdownToggle,
  StyledMenuItem,
} from './Dropdown.styles'
import Text from './Text'

const MangoDropdown = ({
  options,
  showText,
  selected,
  onSelect,
  customMenu,
  customLabel,
  useCase,
}) => {
  const [open, setOpen] = useState(false)

  const DropdownToggle =
    useCase === 'settings' ? StyledDropdownSettingsToggle : StyledDropdownToggle
  const DropdownMenu =
    useCase === 'settings' ? StyledDropdownSettingsMenu : StyledDropdownMenu

  const handleToggleDropdown = (e) => {
    setOpen(e)
  }

  const handleSelectMenu = (e) => () => {
    const { id, value, label } = e
    if (!isNil(id)) {
      onSelect(id)
    } else if (!isNil(value)) {
      onSelect(value)
    } else {
      onSelect(label)
    }
  }

  return (
    <StyledDropdown onToggle={handleToggleDropdown}>
      <DropdownToggle>
        {customLabel ?? <Text size="small" text={showText} />}
        <ImageIcon
          width="14"
          height="7"
          icon={open ? iconArrowUpDark900 : iconArrowDownDark900}
        />
      </DropdownToggle>
      <DropdownMenu>
        {customMenu ??
          options.map((option) => {
            const { id, value, label } = option
            return (
              <StyledMenuItem
                key={`dropdown-menu-${id}-${value}`}
                active={id === selected || value === selected}
                onSelect={handleSelectMenu?.(option)}
              >
                {label}
              </StyledMenuItem>
            )
          })}
      </DropdownMenu>
    </StyledDropdown>
  )
}

MangoDropdown.propTypes = {
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showText: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
      ]),
    }),
  ),
  onSelect: PropTypes.func,
  customMenu: PropTypes.node,
  customLabel: PropTypes.node,
  useCase: PropTypes.string,
}

MangoDropdown.defaultProps = {
  selected: 0,
  showText: 'All',
  options: [],
  onSelect: () => {},
  customMenu: null,
  customLabel: null,
  useCase: 'default',
}

export default MangoDropdown
